import { queryKeys } from '../queryKeys';

import { fetchChannelCollection } from './queryFunctions';

type CreateChannelCollectionQueryOptionsArgs = {
  aggregatedKsql: string | undefined;
  collectionId: number;
  includeAdult: boolean;
};

export function createChannelCollectionQueryOptions({
  aggregatedKsql,
  collectionId,
  includeAdult,
}: CreateChannelCollectionQueryOptionsArgs) {
  return {
    queryKey: queryKeys.channelCollection(collectionId, includeAdult, aggregatedKsql),
    queryFn: () =>
      fetchChannelCollection({
        collectionId,
        includeAdult,
        kSql: aggregatedKsql,
      }),
    staleTime: Infinity,
  };
}
